import { render, staticRenderFns } from "./IncidentesYAccidentesView.vue?vue&type=template&id=6a915905&scoped=true"
import script from "./IncidentesYAccidentesView.vue?vue&type=script&lang=js"
export * from "./IncidentesYAccidentesView.vue?vue&type=script&lang=js"
import style0 from "./IncidentesYAccidentesView.vue?vue&type=style&index=0&id=6a915905&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a915905",
  null
  
)

export default component.exports